// Persisted in activity-table URLs; keep these values stable.
export const HEALTH_FILTER_KEYS = {
    HIGH_FRICTION: "highFriction",
    FRICTION: "friction",
    CLEAN: "clean",
} as const;

export type HealthFilterKey =
    (typeof HEALTH_FILTER_KEYS)[keyof typeof HEALTH_FILTER_KEYS];
